<template>
  <NavMenu />
  <section class="border-t">
    <div class="bg-brand-blue py-8 px-5">
      <div class="max-w-7xl mx-auto">
        <div class="text-white">
          <div class="">
            <div class="text-sm font-bold text-gray-200 mb-5">
              Home / reporting
            </div>
            <h1 class="text-3xl font-bold">Reporting</h1>
          </div>
        </div>
      </div>
    </div>
    <div class="py-20">
      <div class="max-w-7xl mx-auto">
        <div>
          <div class="grid lg:grid-cols-3 gap-8">
            <a
              v-for="(row, i) in rows"
              :key="i"
              href="#"
              class="
                flex
                space-x-3
                p-5
                rounded-xl
                bg-gray-100
                hover:bg-gray-200
                transition-all
              "
              @click.prevent="selectReport(row)"
            >
              <div><DocumentTextIcon class="w-6 h-6" /></div>
              <div>
                <div class="font-bold text-lg">
                  {{ row.name }}
                </div>
                <div class="text-gray-500">{{ row.description }}</div>
              </div>
            </a>
          </div>
        </div>
      </div>
    </div>
  </section>
  <ModalComponent :is-open="modals.create" @close="modals.create = false">
    <template v-slot:title>
      <div class="text-center uppercase">Submit report</div>
    </template>
    <hr />
    <div>
      <div class="py-5 text-center" v-if="reportCreated">
        <div class="">
          <div>Your report has been created.</div>
          <div>Reference number is</div>
          <div class="text-2xl font-bold my-3 py-3 bg-gray-200 rounded-lg">
            {{ reference }}
          </div>
          <!-- <div class="flex justify-center mt-5">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="h-12 w-12"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              stroke-width="2"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M12 4v1m6 11h2m-6 0h-2v4m0-11v3m0 0h.01M12 12h4.01M16 20h4M4 12h4m12 0h.01M5 8h2a1 1 0 001-1V5a1 1 0 00-1-1H5a1 1 0 00-1 1v2a1 1 0 001 1zm12 0h2a1 1 0 001-1V5a1 1 0 00-1-1h-2a1 1 0 00-1 1v2a1 1 0 001 1zM5 20h2a1 1 0 001-1v-2a1 1 0 00-1-1H5a1 1 0 00-1 1v2a1 1 0 001 1z"
              />
            </svg>
          </div> -->

          <div class="font-bold my-5">Click proceed to data entry</div>
          <button class="btn btn-primary w-full" @click="proceed">
            Proceed
          </button>
        </div>
      </div>
      <div class="py-5" v-else>
        <div class="mb-5 text-center">
          <div class="text-xl font-bold">{{ selectedReport.name }}</div>
          <div class="text-gray-600">{{ selectedReport.description }}</div>
        </div>
        <hr />
        <form @submit.prevent="submit">
          <div class="my-5">
            <div class="grid grid-cols-2 gap-5">
              <div class="">
                <label for="atollId">Atoll</label>
                <div>
                  <select
                    name=""
                    id="atollId"
                    class="form-control"
                    @change="onAtollChange"
                    v-model="form.atollId"
                    required
                  >
                    <option :value="row.id" v-for="row in atolls" :key="row.id">
                      {{ row.name }}
                    </option>
                  </select>
                </div>
              </div>
              <div class="">
                <label for="islandId">Island</label>
                <div v-if="hasIslands">
                  <select
                    name=""
                    id="islandId"
                    class="form-control"
                    v-model="form.islandId"
                    required
                  >
                    <option
                      :value="row.id"
                      v-for="row in islands"
                      :key="row.id"
                    >
                      {{ row.name }}
                    </option>
                  </select>
                </div>
                <div v-else>
                  <select name="" id="">
                    <option value="">Select atoll</option>
                  </select>
                </div>
              </div>
              <div class="col-span-2">
                <label for="fullName">Full Name</label>
                <input
                  type="text"
                  class="form-control"
                  v-model="form.fullName"
                  id="fullName"
                  required
                />
              </div>
              <div class="col-span-2">
                <label for="contactNumber">Contact Number</label>
                <input
                  type="text"
                  class="form-input"
                  v-model="form.contactNumber"
                  id="contactNumber"
                  required
                />
              </div>
              <div class="col-span-2">
                <label for="email">Email</label>
                <input
                  type="email"
                  class="form-control"
                  v-model="form.email"
                  id="email"
                  required
                />
              </div>
            </div>
          </div>
          <!-- <button class="btn btn-primary w-full">Create</button> -->
          <SubmitButton
            :storeModule="storeModule"
            text="Proceed"
            class="w-full mt-5"
          />
        </form>
      </div>
    </div>
  </ModalComponent>
  <SectionFooter />
</template>

<script setup>
import NavMenu from "@/components/NavMenu";
import { DocumentTextIcon } from "@heroicons/vue/outline";
import SectionFooter from "@/components/SectionFooter";
import { useStore } from "vuex";
import { computed, onMounted, ref } from "@vue/runtime-core";
// import ModalComponent from "@/components/utils/ModalComponent.vue";
import { useRouter } from "vue-router";

const store = useStore();
const rows = computed(() => store.getters["requestType/data"].rows);
const atolls = computed(() => store.getters["atoll/data"].rows);
const islands = computed(() => store.getters["island/data"].rows);
const storeModule = "reporting";

let modals = ref({
  create: false,
});

onMounted(() => {
  document.title = "Reporting - The Coral Database";
  document
    .querySelector('meta[name="description"]')
    .setAttribute("content", "Reporting at the Coral Database");
});

function init() {
  store.dispatch("http/send", {
    module: "requestType",
    params: {
      serviceTypeCategoryId: 2,
    },
  });
  store.dispatch("http/send", {
    module: "atoll",
  });
}
init();

let hasIslands = ref(false);
function onAtollChange() {
  hasIslands.value = false;
  store
    .dispatch("http/send", {
      module: "island",
      params: {
        atollId: form.value.atollId,
      },
    })
    .then(() => {
      hasIslands.value = true;
    });
}

let selectedReport = ref({});
function selectReport(row) {
  selectedReport.value = row;
  modals.value.create = true;
}
let reference = ref("");
let reportCreated = ref(false);
const router = useRouter();
let form = ref({
  requestTypeId: "",
  atollId: 0,
  islandId: 0,
  fullName: "",
  contactNumber: "",
  email: "",
});
function submit() {
  form.value.requestTypeId = selectedReport.value.id;
  store
    .dispatch("http/send", {
      module: "reporting",
      data: form.value,
      method: "POST",
    })
    .then((res) => {
      reference.value = res.data.reference;
      reportCreated.value = true;
    });
}
function proceed() {
  router.push(`/reporting/${reference.value}/edit`);
}
</script>